export default function BookingSearchForm() {
  return (
    <div id="block-search">
      <div id="be-search-form" className="be-container">
        <a href="https://exely.com/" rel="nofollow" target="_blank">Hotel management software</a>
      </div>
    </div>
  )
}
